import { BrowserRouter as Router } from 'react-router';
import { PrimeReactProvider } from 'primereact/api';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { ToastProvider } from '@/context/ToastContext';
import MainLayout from '@/components/layout/MainLayout';
import AppRoutes from '@/routes/AppRoutes';
import { ThemeProvider } from '@/context/ThemeContext';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primeicons/primeicons.css';
import '@/index.css';

function App() {
  
  return (
    <ThemeProvider>
      <PrimeReactProvider value={{ ripple: false }}>
        <Router>
          <ToastProvider>
            <MainLayout>
              <AppRoutes />
            </MainLayout>
          </ToastProvider>
        </Router>
        <ConfirmDialog />
      </PrimeReactProvider>
    </ThemeProvider>
  );
}

export default App;
